import Landing from "../components/home/Landing";
import Highlights from "../components/home/Highlights";
import Features from "../components/home/Features";
import Discounted from "../components/home/Discounted";
import Explore from "../components/home/Explore";

export default function Home({ books }) {
  return (
    <>
      <Landing />
      <Highlights />
      <Features books={books} />
      <Discounted books={books} />
      <Explore />
    </>
  );
}
